import React from "react";
import { Wallet, Plus, Trash2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { SectionToggle, NumInput } from "./shared";

const NEW_STREAM = { name: "Social Security", annual_amount: 24000, start_age: 67, end_age: null, cola: true };

export default function IncomeStreamsSection({ inputs, setInputs, open, onToggle }) {
  const addStream = () => {
    setInputs({ ...inputs, income_streams: [...(inputs.income_streams || []), { ...NEW_STREAM }] });
  };
  const updateStream = (i, k, v) => {
    setInputs({
      ...inputs,
      income_streams: inputs.income_streams.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)),
    });
  };
  const removeStream = (i) => {
    setInputs({ ...inputs, income_streams: inputs.income_streams.filter((_, idx) => idx !== i) });
  };

  const streamCount = inputs.income_streams?.length ?? 0;

  return (
    <div>
      <SectionToggle
        testId="toggle-income"
        icon={Wallet}
        title="Income streams"
        subtitle="Social Security, pensions, annuities"
        badge={streamCount ? `${streamCount} active` : "none"}
        open={open}
        onToggle={onToggle}
      />
      {open && (
        <div className="pb-5 space-y-3">
          {(inputs.income_streams || []).map((s, i) => (
            <div
              key={`stream-${s.name}-${s.start_age}-${i}`}
              data-testid={`income-stream-${i}`}
              className="bg-[#F9F8F6] border border-[#E5E2DC] rounded-xl p-4 space-y-3"
            >
              <div className="flex items-center justify-between gap-2">
                <Input
                  data-testid={`income-name-${i}`}
                  value={s.name}
                  onChange={(e) => updateStream(i, "name", e.target.value)}
                  className="border-0 bg-transparent px-0 focus-visible:ring-0 font-medium text-[#1C2B23] h-8 text-sm"
                />
                <button
                  data-testid={`income-remove-${i}`}
                  type="button"
                  onClick={() => removeStream(i)}
                  className="text-[#C26747] hover:text-[#a04d33] p-1"
                >
                  <Trash2 size={14} />
                </button>
              </div>
              <NumInput id={`stream-amt-${i}`} testid={`income-amount-${i}`} label="Annual amount" value={s.annual_amount} onChange={(v) => updateStream(i, "annual_amount", v)} prefix="$" step={500} />
              <div className="grid grid-cols-2 gap-3">
                <NumInput id={`stream-start-${i}`} testid={`income-start-${i}`} label="Start age" value={s.start_age} onChange={(v) => updateStream(i, "start_age", v)} suffix="yrs" />
                <NumInput id={`stream-end-${i}`} testid={`income-end-${i}`} label="End age (blank = lifetime)" value={s.end_age ?? ""} onChange={(v) => updateStream(i, "end_age", v === "" ? null : v)} suffix="yrs" />
              </div>
              <div className="flex items-center justify-between text-sm">
                <Label className="text-[#5C6B62]">COLA (inflation-adjust)</Label>
                <Switch data-testid={`income-cola-${i}`} checked={s.cola} onCheckedChange={(v) => updateStream(i, "cola", v)} />
              </div>
            </div>
          ))}
          <button
            data-testid="btn-add-income"
            type="button"
            onClick={addStream}
            className="w-full border border-dashed border-[#2B5339] text-[#2B5339] rounded-xl py-2.5 text-sm inline-flex items-center justify-center gap-2 hover:bg-[#F0EFEA] transition-colors"
          >
            <Plus size={14} /> Add income stream
          </button>
        </div>
      )}
    </div>
  );
}
